var _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeDoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#B0E7F7",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11502_4483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 38,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H47V46H9V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11502_4483)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9999 38.5781C29.8395 38.5781 31.3398 37.0778 31.3398 35.2383C31.3398 33.3988 29.8395 31.8984 27.9999 31.8984C26.1604 31.8984 24.6601 33.3988 24.6601 35.2383C24.6601 37.0778 26.1604 38.5781 27.9999 38.5781Z",
    fill: "#FFDDCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9999 45.2578H21.3203C21.3203 41.5687 24.3108 38.5781 27.9999 38.5781C31.6891 38.5781 34.6796 41.5687 34.6796 45.2578H27.9999Z",
    fill: "#D675A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3203 35.2383C23.1598 35.2383 24.6601 33.7379 24.6601 31.8984C24.6601 30.0589 23.1598 28.5585 21.3203 28.5585C19.4807 28.5585 17.9804 30.0589 17.9804 31.8984C17.9804 33.7379 19.4807 35.2383 21.3203 35.2383Z",
    fill: "#FFDDCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3203 41.918H14.6406C14.6406 38.2289 17.6311 35.2383 21.3203 35.2383C22.598 35.2383 23.7919 35.5972 24.8068 36.2195C25.1307 37.2748 25.9633 38.1074 27.0186 38.4313C27.0594 38.4979 27.0991 38.5652 27.1376 38.6333C25.0313 38.9048 23.2325 40.1574 22.214 41.918H21.3203Z",
    fill: "#B0E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6796 35.2383C36.5191 35.2383 38.0195 33.7379 38.0195 31.8984C38.0195 30.0589 36.5191 28.5585 34.6796 28.5585C32.8401 28.5585 31.3398 30.0589 31.3398 31.8984C31.3398 33.7379 32.8401 35.2383 34.6796 35.2383Z",
    fill: "#FFDDCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6805 41.918H33.7867C32.7682 40.1574 30.9695 38.9048 28.8632 38.6333C28.9017 38.5652 28.9414 38.4979 28.9822 38.4313C30.0374 38.1074 30.87 37.2748 31.1939 36.2196C32.2089 35.5972 33.4027 35.2383 34.6805 35.2383C38.3696 35.2383 41.3602 38.2289 41.3602 41.918H34.6805Z",
    fill: "#B0AEEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9999 37.8359C26.5703 37.8359 25.4023 36.6679 25.4023 35.2383C25.4023 33.8087 26.5703 32.6406 27.9999 32.6406C29.4296 32.6406 30.5976 33.8087 30.5976 35.2383C30.5976 36.6679 29.4296 37.8359 27.9999 37.8359ZM23.9179 35.2383C23.9179 37.4877 25.7505 39.3203 27.9999 39.3203C30.2493 39.3203 32.082 37.4877 32.082 35.2383C32.082 32.9889 30.2493 31.1563 27.9999 31.1563C25.7505 31.1563 23.9179 32.9889 23.9179 35.2383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5781 45.2578C20.5781 45.6677 20.9104 46 21.3203 46H34.6796C35.0895 46 35.4218 45.6677 35.4218 45.2578C35.4218 41.1588 32.099 37.8359 27.9999 37.8359C23.9009 37.8359 20.5781 41.1588 20.5781 45.2578ZM22.1084 44.5156C22.4736 41.5867 24.9721 39.3203 27.9999 39.3203C31.0278 39.3203 33.5263 41.5867 33.8915 44.5156H22.1084Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3203 34.4961C19.8906 34.4961 18.7226 33.3281 18.7226 31.8984C18.7226 30.4687 19.8906 29.3007 21.3203 29.3007C22.7499 29.3007 23.9179 30.4687 23.9179 31.8984C23.9179 33.3281 22.7499 34.4961 21.3203 34.4961ZM17.2382 31.8984C17.2382 34.1478 19.0708 35.9805 21.3203 35.9805C23.5697 35.9805 25.4023 34.1478 25.4023 31.8984C25.4023 29.649 23.5697 27.8163 21.3203 27.8163C19.0708 27.8163 17.2382 29.649 17.2382 31.8984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8984 41.918C13.8984 42.3279 14.2307 42.6602 14.6406 42.6602H22.214C22.6239 42.6602 22.9562 42.3279 22.9562 41.918C22.9562 41.5081 22.6239 41.1758 22.214 41.1758H15.4287C15.7939 38.2469 18.2924 35.9805 21.3203 35.9805C22.4572 35.9805 23.5173 36.2994 24.4187 36.8523C24.7681 37.0666 25.2251 36.9571 25.4394 36.6077C25.6537 36.2583 25.5442 35.8013 25.1948 35.587C24.0666 34.895 22.7389 34.4961 21.3203 34.4961C17.2212 34.4961 13.8984 37.819 13.8984 41.918Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6796 34.4961C33.25 34.4961 32.082 33.3281 32.082 31.8984C32.082 30.4687 33.25 29.3007 34.6796 29.3007C36.1092 29.3007 37.2773 30.4687 37.2773 31.8984C37.2773 33.3281 36.1092 34.4961 34.6796 34.4961ZM30.5976 31.8984C30.5976 34.1478 32.4302 35.9805 34.6796 35.9805C36.929 35.9805 38.7617 34.1478 38.7617 31.8984C38.7617 29.649 36.929 27.8163 34.6796 27.8163C32.4302 27.8163 30.5976 29.649 30.5976 31.8984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7989 41.918C39.7989 42.3279 40.1312 42.6602 40.5411 42.6602H41.3593C41.7692 42.6602 42.1015 42.3279 42.1015 41.918C42.1015 37.819 38.7786 34.4961 34.6796 34.4961C33.2609 34.4961 31.9334 34.8951 30.8052 35.5869C30.4558 35.8011 30.3462 36.2581 30.5604 36.6076C30.7747 36.957 31.2317 37.0666 31.5811 36.8523C32.4828 36.2995 33.5428 35.9805 34.6796 35.9805C37.7075 35.9805 40.2059 38.2469 40.5711 41.1758H40.5411C40.1312 41.1758 39.7989 41.5081 39.7989 41.918Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0446 41.918C33.0446 42.3279 33.3769 42.6602 33.7868 42.6602H40.9153C41.3252 42.6602 41.6575 42.3279 41.6575 41.918C41.6575 41.5081 41.3252 41.1758 40.9153 41.1758H33.7868C33.3769 41.1758 33.0446 41.5081 33.0446 41.918Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2615 16.9482C33.2615 14.0428 30.9063 11.6875 28.0009 11.6875C25.0956 11.6875 22.7402 14.0428 22.7402 16.9482C22.7402 19.0712 23.998 20.9002 25.809 21.7314V23.0469H30.1928V21.7314C32.0037 20.9002 33.2615 19.0712 33.2615 16.9482Z",
    fill: "#FFC059"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1925 23.0475H25.8086V24.8012C25.8086 25.7656 26.5976 26.5547 27.5621 26.5547H28.4389C29.4033 26.5547 30.1925 25.7656 30.1925 24.8012V23.0475Z",
    fill: "#858FA6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0667 24.8012C25.0667 26.1755 26.1881 27.2969 27.5624 27.2969H28.4393C29.8135 27.2969 30.935 26.1755 30.935 24.8012V22.1863C32.7649 21.1591 34.0037 19.1994 34.0037 16.9488C34.0037 13.6335 31.3161 10.946 28.0009 10.946C27.6221 10.946 27.2516 10.9815 26.8924 11.0486C26.4895 11.1239 26.2238 11.5115 26.2991 11.9144C26.3743 12.3174 26.762 12.583 27.1649 12.5078C27.436 12.4571 27.7152 12.4303 28.0009 12.4303C30.4963 12.4303 32.5193 14.4533 32.5193 16.9488C32.5193 18.7711 31.4403 20.3428 29.8832 21.0575C29.6196 21.1785 29.4506 21.442 29.4506 21.732V24.8012C29.4506 25.3557 28.9938 25.8125 28.4393 25.8125H27.5624C27.0079 25.8125 26.5511 25.3557 26.5511 24.8012V21.732C26.5511 21.442 26.3821 21.1785 26.1185 21.0575C24.5614 20.3428 23.4824 18.7711 23.4824 16.9488C23.4824 16.6631 23.5092 16.3839 23.5598 16.1128C23.6351 15.7099 23.3695 15.3223 22.9665 15.247C22.5636 15.1718 22.1759 15.4374 22.1007 15.8403C22.0336 16.1996 21.998 16.57 21.998 16.9488C21.998 19.1994 23.2367 21.1591 25.0667 22.1863V24.8012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0664 23.0469C25.0664 23.4568 25.3987 23.7891 25.8086 23.7891H30.1925C30.6024 23.7891 30.9347 23.4568 30.9347 23.0469C30.9347 22.637 30.6024 22.3047 30.1925 22.3047H25.8086C25.3987 22.3047 25.0664 22.637 25.0664 23.0469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 9.80078C28.4099 9.80078 28.7422 9.46849 28.7422 9.05859V8.74294C28.7422 8.33304 28.4099 8.00075 28 8.00075C27.5901 8.00075 27.2578 8.33304 27.2578 8.74294V9.05859C27.2578 9.46849 27.5901 9.80078 28 9.80078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4254 10.7579C24.7804 10.553 24.9021 10.0991 24.6972 9.74407L24.5394 9.47072C24.3345 9.11572 23.8806 8.99406 23.5256 9.19898C23.1706 9.4039 23.0489 9.85781 23.2538 10.2128L23.4116 10.4862C23.6165 10.8412 24.0704 10.9628 24.4254 10.7579Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8088 13.3709C22.0138 13.0159 21.8921 12.562 21.5371 12.3571L21.2637 12.1993C20.9087 11.9944 20.4548 12.116 20.2499 12.471C20.045 12.826 20.1667 13.2799 20.5217 13.4849L20.795 13.6427C21.15 13.8476 21.6039 13.7259 21.8088 13.3709Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0508 16.9531C19.0508 17.363 19.3831 17.6953 19.793 17.6953H20.1086C20.5185 17.6953 20.8508 17.363 20.8508 16.9531C20.8508 16.5432 20.5185 16.2109 20.1086 16.2109H19.793C19.3831 16.2109 19.0508 16.5432 19.0508 16.9531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1484 16.9531C35.1484 17.363 35.4807 17.6953 35.8906 17.6953H36.2062C36.6161 17.6953 36.9484 17.363 36.9484 16.9531C36.9484 16.5432 36.6161 16.2109 36.2062 16.2109H35.8906C35.4807 16.2109 35.1484 16.5432 35.1484 16.9531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1913 13.3709C34.3962 13.7259 34.8502 13.8476 35.2052 13.6427L35.4785 13.4849C35.8335 13.2799 35.9552 12.826 35.7502 12.471C35.5453 12.116 35.0914 11.9944 34.7364 12.1993L34.4631 12.3571C34.1081 12.562 33.9864 13.0159 34.1913 13.3709Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5741 10.7578C31.929 10.9628 32.383 10.8412 32.588 10.4863L32.7458 10.2129C32.9508 9.85798 32.8292 9.40405 32.4743 9.19906C32.1193 8.99406 31.6654 9.11563 31.4604 9.47059L31.3025 9.74394C31.0976 10.0989 31.2191 10.5528 31.5741 10.7578Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7365 13.7075C23.9989 14.0224 24.4669 14.065 24.7818 13.8026L24.7822 13.8022C25.0971 13.5398 25.1397 13.0718 24.8773 12.7569C24.6149 12.442 24.1469 12.3995 23.832 12.6619L23.8315 12.6622C23.5166 12.9247 23.4741 13.3926 23.7365 13.7075Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeDoIcon);
export default __webpack_public_path__ + "static/media/we_do_icon.f6a7977415b4a09ac89447c0315ccbe4.svg";
export { ForwardRef as ReactComponent };